'use client';

import styled from '@emotion/styled';
import { themed, ITheme } from '../../themer';
import { Css, Responsive } from '../../utils';
import { ImageWrap } from '../Image';
import { StyledAlert } from '../Alert';

export const contentWrapBreakpoint = themed(
	({ layout }) =>
		`max-width: ${Css.calc(
			layout.main.maxWidth,
			(v) => v + parseInt(layout.main.margin.tablet, 10) * 2,
		)}`,
);

export const ContentWrap = styled.div<{}, ITheme>`
	max-width: ${themed(({ layout }) => layout.main.maxWidth)};
	margin: 0 auto;

	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	p,
	li,
	img,
	blockquote {
		max-width: ${themed(({ layout }) => layout.main.textMaxWidth)};

		@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
			max-width: ${themed(({ layout }) => layout.main.tablet.textMaxWidth)};
		}

		@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
			max-width: ${themed(({ layout }) => layout.main.mobile.textMaxWidth)};
		}
	}

	.no-max-width {
		max-width: unset;
	}

	p,
	blockquote {
		&:last-child {
			margin-bottom: 0;
		}

		+ h1,
		+ h2,
		+ h3,
		+ h4 {
			padding-top: 16px;
		}
	}

	${ImageWrap} {
		text-align: ${themed(({ layout }) => layout.image.align)};
		padding: ${themed(({ layout }) => layout.image.padding)};

		> &:last-child {
			padding-bottom: 0;
		}

		img {
			display: block;
			width: ${themed(({ layout }) => layout.image.width)};
			max-width: ${themed(({ layout }) => layout.image.maxWidth)};
			max-height: ${themed(({ layout }) => layout.image.maxHeight)};
			border-radius: ${themed(({ layout }) => layout.image.borderRadius)};
		}
	}

	${StyledAlert} {
		max-width: ${themed(({ layout }) => layout.main.textMaxWidth)};
	}

	@media (${contentWrapBreakpoint}) {
		max-width: none;
		margin: 0 ${themed(({ layout }) => layout.main.margin.tablet)};
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin: 0 ${themed(({ layout }) => layout.main.margin.mobile)};

		${ImageWrap} {
			padding: ${themed(({ layout }) => layout.image.mobile.padding)};

			img {
				width: ${themed(({ layout }) => layout.image.mobile.width)};
				max-width: ${themed(({ layout }) => layout.image.mobile.maxWidth)};
			}
		}
	}
	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		${ImageWrap} {
			img {
				max-width: ${themed(({ layout }) => layout.image.tablet.maxWidth)};
			}
		}
	}
`;
